/* Menu components */
import MenuTopWrapper from './Menu/MenuTopWrapper';
import MenuNavListItem from './Menu/MenuNavListItem';
import MenuContainer from './Menu/MenuContainer';
import MenuContent from './Menu/MenuContent';

/* Avatar components */
import AvatarPhoto from './Avatar/AvatarPhoto';

/* PhotoUploader components */
import PhotoUploaderModalFooter from './PhotoUploader/PhotoUploaderModalFooter';

/* Dropdown component */
import {
  DropdownContainer,
  DropdownIcon,
  DropdownContentWrapper,
} from './Dropdown/index';

import { ClassroomsDefaultTheme } from './Texter/Texter.theme';

/* Card components */
import CardContainer from './Card/CardContainer';

/* EventCalendar components */
import EventCalendar from './EventCalendar/EventCalendar';
import CalendarHeader from './EventCalendar/CalendarHeader';
import BodyModal from './EventCalendar/BodyModal';
import Calendar from './EventCalendar/Calendar';
import CardMessageType from './EventCalendar/CardMessageType';
import ConfirmationModal from './EventCalendar/ConfirmationModal';
import Dropdown from './EventCalendar/Dropdown';
import EventTypeSelect from './EventCalendar/EventTypeSelect';
import HeaderModal from './EventCalendar/HeaderModal';
import List from './EventCalendar/List';
import TagLabel from './EventCalendar/Tag';
import CalendarEventForm from './CalendarEventForm/CalendarEventForm';
import InputHour from './InputHour';
import InputDatepicker from './InputDatepicker';
import Form from './Form';
import CheckboxElement from './CheckboxElement/CheckboxElement';
import CheckboxLabel from './CheckboxLabel/CheckboxLabel';
import CheckboxWrapper from './CheckboxWrapper/CheckboxWrapper';
import Feed from './Feed/Feed';
import Paginator from './Paginator/Paginator';

export const lego = {
  /* Card components */
  CardContainer,
  /* Menu components */
  MenuTopWrapper,
  MenuContent,
  MenuContainer,
  MenuNavListItem,
  /* Avatar components */
  AvatarPhoto,
  /* PhotoUploader components */
  PhotoUploaderModalFooter,

  /*Dropdown component */
  DropdownContainer,
  DropdownIcon,
  DropdownContentWrapper,
  Texter: ClassroomsDefaultTheme,
  /* EventCalendar components */
  EventCalendar,
  CalendarHeader,
  BodyModal,
  Calendar,
  CardMessageType,
  ConfirmationModal,
  Dropdown,
  EventTypeSelect,
  HeaderModal,
  List,
  TagLabel,
  CalendarEventForm,
  ...InputDatepicker,
  ...InputHour,
  ...Form,
  CheckboxElement,
  CheckboxLabel,
  CheckboxWrapper,
  Feed,
  Paginator,
};
